import {
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  RadioGroupProps,
  Stack,
  Typography,
} from '@mui/material';
import useI18n, { Ti18nId } from 'hooks/useI18n';
import Form from 'components/Form';
import { IFormRegister } from 'routes/Main/type';

interface Props extends RadioGroupProps, IFormRegister {
  i18nKey?: string;
  i18nNullKey?: string;
  value?: number;
  values: number[];
  defaultValue: number;
  disabled?: boolean;
  width?: string;
  direction?: string;
  whiteSpace?: string;
  onChange?: (value: any) => void;
}

const VAECMO_1_Column = ({
  i18nKey,
  i18nNullKey,
  values,
  defaultValue,
  disabled,
  width,
  whiteSpace,
  direction,
  onChange,
  register,
  ...props
}: Props) => {
  const i18n = useI18n();
  const label = (value: number) => {
    if (!value && i18nNullKey) return i18n(i18nNullKey as Ti18nId);
    if (i18nKey) return i18n(`${i18nKey}.${value}` as Ti18nId);
    return '';
  };

  return (
    <RadioGroup
      row
      defaultValue={defaultValue}
      sx={{
        flexWrap: 'wrap',
        whiteSpace: 'pre-wrap',
        display: 'flex',
        width: '1200px',
      }}
      onChange={(_, value) => onChange && onChange(value)}
      {...props}
    >
      {values.map(value => {
        if (value === 2) {
          return (
            <Stack direction="row" sx={{ margin: '3px 0 3px 0' }}>
              <FormControlLabel
                key={value}
                value={value}
                disabled={disabled}
                control={<Radio size="small" />}
                label={
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: 400,
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {label(value)}
                  </Typography>
                }
                sx={{ width: '480px' }}
              />
              <Form.MuiTextField
                placeholder="직접 입력"
                required={false}
                fullWidth={false}
                disabled={disabled}
                {...register('treatment_reason.va_shock_condition_input1')}
              />
            </Stack>
          );
        } else if (value === 3) {
          return (
            <Grid xs={11}>
              <Stack direction="row">
                <FormControlLabel
                  key={value}
                  value={value}
                  disabled={disabled}
                  control={<Radio size="small" />}
                  label={
                    <Typography
                      sx={{
                        fontSize: '12px',
                        fontWeight: 400,
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {label(value)}
                    </Typography>
                  }
                  sx={{ width: '300px' }}
                />
                <Form.MuiTextField
                  placeholder="직접 입력"
                  required={false}
                  disabled={disabled}
                  fullWidth
                  sx={{ fontSize: '12px' }}
                  {...register('treatment_reason.va_shock_condition_input2')}
                />
              </Stack>
            </Grid>
          );
        } else {
          return (
            <Stack direction="row">
              <FormControlLabel
                key={value}
                value={value}
                disabled={disabled}
                control={<Radio size="small" />}
                label={
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: 400,
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {label(value)}
                  </Typography>
                }
                sx={{ width: '60vw' }}
              />
            </Stack>
          );
        }
      })}
    </RadioGroup>
  );
};

export default VAECMO_1_Column;
